// HomeBannerItem.js
'use strict';
import { connect } from 'react-redux';

import HomeBannerItem from '../component/HomeBannerItem.jsx';

import fetchBanner from '../action/fetchBanner.js';
import toggleModal from '../action/toggleModal.js';
import getBanner from '../selector/getBanner.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (state, { bannerLink }) => {
  return {
    bannerData: getBanner(state, bannerLink),
    meId: getMeData(state, 'id'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchBanner: ({ category, url }) =>
      dispatch(fetchBanner({ category, url })),
    toggleModal: ({ modalId, payload, isOpen, modalOption }) =>
      dispatch(toggleModal({ modalId, payload, isOpen, modalOption })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeBannerItem);
